// frontend/src/contexts/HeaderDrawerContext.tsx
import React, { createContext, useContext, useState, useMemo } from 'react';

interface HeaderDrawerContextValue {
  isHeaderDrawerOpen: boolean;
  setHeaderDrawerOpen: (open: boolean) => void;
}

const HeaderDrawerContext = createContext<HeaderDrawerContextValue | undefined>(
  undefined
);

export const HeaderDrawerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isHeaderDrawerOpen, setHeaderDrawerOpen] = useState(false);

  const value = useMemo(
    () => ({ isHeaderDrawerOpen, setHeaderDrawerOpen }),
    [isHeaderDrawerOpen]
  );

  return (
    <HeaderDrawerContext.Provider value={value}>
      {children}
    </HeaderDrawerContext.Provider>
  );
};

export const useHeaderDrawer = (): HeaderDrawerContextValue => {
  const context = useContext(HeaderDrawerContext);
  if (context === undefined) {
    throw new Error(
      'useHeaderDrawer must be used within a HeaderDrawerProvider'
    );
  }
  return context;
};
